import React, { Component } from 'react';
import styled from 'styled-components';

const Div = styled.div`
  display: inline-block;
  width: 100%;
  margin: 0;
  vertical-align: sub;
  font-weight: normal;
  font-size: 0.925rem;
  font-weight: 500;
  padding: 4px;
  background-color: red;
  color: white;
`;

class ConfigError extends Component {
  render() {
    const { dataid, configErrorMessage } = this.props;
    return (
      <Div>
        Field {dataid} configuration error - {configErrorMessage}
      </Div>
    );
  }
}

export default ConfigError;
